import React, { useState, useEffect } from "react";
import { Row, Col, Card, Input, Divider, Button, Select } from "antd";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { CatalogAction } from "../../store/actions";
import { useHistory } from "react-router-dom";
import { fontSize } from "@mui/system";

const { Option } = Select;
const CardWrapper = styled(Card)`
  min-height: 400px;
`;

const arr = [];
const { TextArea } = Input;
function Basemix_Info({ isShowUpdateProduct, textHeading, location }) {
  console.log("location.state===>", location.state);
  const [productId, setProductId] = useState(location?.state?.id);
  let [isOpenModal, setIsOpenModal] = useState(false);
  let [isAdditiveModal, setIsAdditiveModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const categories = useSelector((store) => store?.CatalogReducer?.categories);

  const dispatch = useDispatch();
  const history = useHistory();

  const getBasemixCategories = (params) =>
    dispatch(CatalogAction.getBasemixCategoriesReq(params));
  const postBasemixesCategories = (payload, cb) =>
    dispatch(CatalogAction.postBasemixCategoriesReq(payload, cb));
  const postBasemixesReq = (payload, cb) =>
    dispatch(CatalogAction.postBasemixesReq(payload, cb));

  useEffect(() => {
    getBasemixCategories();
  }, []);

  const basemixData = useSelector(
    (store) => store?.CatalogReducer?.basemixData
  );
  const additivesData = useSelector(
    (store) => store?.CatalogReducer?.additives
  );
  const dataInBasemix = useSelector(
    (store) => store?.CatalogReducer?.basemixes
  );

  const [category, setCategory] = useState([]);
  const [basemix, setBasemix] = useState([]);
  const [additives, setAdditives] = useState([]);
  const [basemixDeatil, setBasemixDetail] = useState({});

  const [customProduct, setCustomProduct] = useState(
    {
      ...location?.state,
      basemix_category_id: location?.state?.basemix_category?.id,
    } || {
      name: "",
    }
  );
  const [customError, setCustomError] = useState({
    nameError: "",
    basemix_category_idError: "",
    basemix_idError: "",
  });

  const [basemixCategories, setBasemixCategories] = useState({
    name: "",
    alias: "",
    description: "",
  });

  const [basemixCategoriesError, setBasemixCategoriesError] = useState({
    nameError: "",
  });

  // if (!arr.length) {
  //   const abc = basemixData.forEach((item) => {
  //     item.basemixes.map((v) => {
  //       arr.push({ name: v.name, id: v.id });
  //     });
  //   });
  // }

  const postCustomProductData = (customProduct) => {
    const err = { ...customError };

    if (
      !customProduct?.name?.trim()?.length ||
      !customProduct?.basemix_category_id
      // !customProduct?.basemix_category_id?.name.trim()?.length
    ) {
      if (!customProduct?.name?.trim().length) {
        err.nameError = "Basemix name is required.";
      }
      if (!customProduct.basemix_category_id) {
        err.basemix_category_idError = "Category is required.";
      }
      // if (!customProduct?.basemix_category_id?.name.trim()?.length) {
      //   err.basemix_category_idError = "Category is required.";
      // }
      setCustomError(err);
      return;
    }
    if (location?.state?.id) {
      const { alias, basemix_category_id, description, name } = customProduct;
      console.log("custom===>", location?.state?.id);
      dispatch(
        CatalogAction.updateBasemixCategoriesReq(
          {
            alias,
            basemix_category_id,
            description,
            name,
          },
          productId,
          () => history.push("/product")
        )
      );
    } else {
      dispatch(
        CatalogAction.postBasemixesReq(customProduct, () =>
          history.push("/product")
        )
      );
    }
  };

  const postBasemixesCategoriesData = (basemixCategories) => {
    const err = { ...basemixCategoriesError };
    if (!basemixCategories.name.trim().length) {
      if (!basemixCategories.name.trim().length) {
        err.nameError = "Name is required";
      }
      setBasemixCategoriesError(err);
      return;
    }
    dispatch(
      CatalogAction.postBasemixCategoriesReq(basemixCategories, () => {
        history.push("/product");
      })
    );
  };

  // let inputRef;
  return (
    <CardWrapper style={{ marginTop: "10px" }}>
      <Row gutter={[0, 10]}>
        <Col
          span={24}
          className="st-table-header"
          style={{ marginBottom: "10px" }}
        >
          <h5
            className="text-left general-text-heading  "
            style={{
              fontSize: "20px",
              color: "#323761",
            }}
          >
            {!location?.state?.id ? "New Basemix" : " Update Basemix"}
          </h5>
        </Col>
        <Col xl={24} lg={12} md={24} sm={24} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={24} lg={24} xs={11} sm={11} md={24} className="text-left">
              <label style={{ fontSize: "12px" }}>
                Basemix Name
                <span style={{ color: "orange", fontSize: "10px" }}>*</span>
              </label>
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Input
                onChange={(e) => {
                  setCustomProduct({
                    ...customProduct,
                    name: e.target.value,
                  });
                  setCustomError({
                    ...customError,
                    nameError: "",
                  });
                }}
                value={customProduct?.name}
              />
              <Row justify="start">
                <Col>
                  <span className="danger-color text-left">
                    {customError.nameError && customError.nameError}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xl={6} lg={4} md={24} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} lg={12} xs={9} sm={9} md={4} className="text-left">
              <label style={{ fontSize: "12px" }}>Basemix Alias</label>
            </Col>
            <Col xl={23} xs={24}>
              <Input
                onChange={(e) => {
                  setCustomProduct({
                    ...customProduct,
                    alias: e.target.value,
                  });
                }}
                value={customProduct?.alias}
              />
            </Col>
          </Row>
        </Col>
        <Col xl={6} md={24} lg={6} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} sm={12} md={5} lg={12} className="text-left">
              <label style={{ fontSize: "12px" }}>
                Categories
                <span style={{ color: "orange", fontSize: "9px" }}>*</span>
              </label>
            </Col>
            <Col xl={24} xs={24}>
              <Select
                style={{ width: "100%", textAlign: "left" }}
                onChange={(e, i) => {
                  setCustomProduct({
                    ...customProduct,
                    basemix_category_id: i?.value,
                    basemix_category: {
                      ...customProduct?.basemix_category,
                      name: i?.children,
                    },
                  });
                  setCustomError({
                    ...customError,
                    basemix_category_idError: "",
                  });
                }}
                placeholder="Categories"
                value={customProduct?.basemix_category?.name}
              >
                {(basemixData || []).map((productName) => {
                  return (
                    <Option key={productName.id} value={productName.id}>
                      {productName.name}
                    </Option>
                  );
                })}
              </Select>
              <Row justify="start">
                <Col>
                  <span className="danger-color text-right">
                    {customError.basemix_category_idError &&
                      customError.basemix_category_idError}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        <Col xl={24} sm={12} md={6} lg={12} className="text-left">
          <Row justify="start">
            <Col xl={12} xs={24} md={24}>
              <label style={{ fontSize: "12px" }}>Basemix Description</label>
              <TextArea
                autoSize={{ minRows: 3, maxRows: 5 }}
                onChange={(e) =>
                  setCustomProduct({
                    ...customProduct,
                    description: e.target.value,
                  })
                }
                value={customProduct?.description}
              />
            </Col>
          </Row>
        </Col>
        <Col xl={12}>
          <Row justify="end">
            <Col xl={6} lg={6} md={6} xs={24} sm={24}>
              <Button
                style={{
                  backgroundColor: "#f57c00 ",
                  color: "#fff",
                  letterSpacing: ".5px",
                  transition: ".2s ease-out(red)",
                  fontSize: "12px",
                }}
                block
                onClick={() => postCustomProductData(customProduct)}
              >
                SAVE
              </Button>
            </Col>
          </Row>
        </Col>
        {!location?.state?.id && (
          <>
            <Col
              span={24}
              className="st-table-header"
              style={{ marginBottom: "10px" }}
            >
              <h5
                className="text-left general-text-heading  "
                style={{
                  fontSize: "20px",
                  color: "#323761",
                }}
              >
                New Basemix Category
              </h5>
            </Col>
            <Col xl={6} lg={4} md={24} xs={24}>
              <Row align="middle" justify="start">
                <Col xl={12} lg={12} xs={9} sm={9} md={4} className="text-left">
                  <label style={{ fontSize: "12px" }}>
                    Name
                    <span style={{ color: "orange", fontSize: "10px" }}>*</span>
                  </label>
                </Col>
                <Col xl={23} xs={24}>
                  <Input
                    onChange={(e) => {
                      setBasemixCategories({
                        ...basemixCategories,
                        name: e.target.value,
                      });
                      setBasemixCategoriesError({
                        nameError: "",
                      });
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <span className="danger-color text-right">
                    {basemixCategoriesError.nameError &&
                      basemixCategoriesError.nameError}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col xl={6} lg={4} md={24} xs={24}>
              <Row align="middle" justify="start">
                <Col xl={12} lg={12} xs={9} sm={9} md={4} className="text-left">
                  <label style={{ fontSize: "12px" }}>Alias</label>
                </Col>
                <Col xl={24} xs={24}>
                  <Input
                    onChange={(e) => {
                      setBasemixCategories({
                        ...basemixCategories,
                        alias: e.target.value,
                      });
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col xl={24} sm={12} md={6} lg={12} className="text-left">
              <Row justify="start">
                <Col xl={12} xs={24} md={24}>
                  <label style={{ fontSize: "12px" }}>Description</label>
                  <TextArea
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    onChange={(e) =>
                      setBasemixCategories({
                        ...basemixCategories,
                        description: e.target.value,
                      })
                    }
                  />
                </Col>
              </Row>
            </Col>
            <Col xl={12}>
              <Row justify="end">
                <Col xl={6} lg={6} md={6} xs={24} sm={24}>
                  <Button
                    style={{
                      backgroundColor: "#f57c00 ",
                      color: "#fff",
                      letterSpacing: ".5px",
                      transition: ".2s ease-out(red)",
                      fontSize: "12px",
                    }}
                    block
                    onClick={() =>
                      postBasemixesCategoriesData(basemixCategories)
                    }
                  >
                    SAVE
                  </Button>
                </Col>
              </Row>
            </Col>
          </>
        )}
      </Row>
    </CardWrapper>
  );
}
export default Basemix_Info;
